import posthog from 'posthog-js';

/**
 * PostHog wrapper for the admin app — same shape as the customer +
 * partner ones. Autocapture is on so we get a view of what admins
 * spend their time on without instrumenting each page.
 */

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  const key = (import.meta as any).env?.VITE_POSTHOG_KEY as string | undefined;
  const host = ((import.meta as any).env?.VITE_POSTHOG_HOST as string | undefined)
    ?? 'https://eu.i.posthog.com';
  if (!key) return;

  posthog.init(key, {
    api_host: host,
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: true,
    persistence: 'localStorage+cookie',
    person_profiles: 'identified_only',
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,
      recordHeaders: false,
      recordBody: false,
    },
    loaded: (ph) => { ph.register({ app: 'admin' }); },
  });
  initialized = true;
}

export function identify(userId: string | null | undefined, traits?: Record<string, unknown>) {
  if (!initialized || !userId) return;
  posthog.identify(userId, traits);
}

export function resetIdentity() {
  if (!initialized) return;
  posthog.reset();
}

export function trackPageView(screen: string, properties?: Record<string, unknown>) {
  if (!initialized) return;
  posthog.capture('$pageview', { screen, ...properties });
}

export function track(event: string, properties?: Record<string, unknown>) {
  if (!initialized) return;
  posthog.capture(event, properties);
}

export { posthog };
